import type { PropertyInterface } from './PropertyInterface'

export abstract class AbstractIntProperty implements PropertyInterface {
  abstract KEY: string

  constructor(private readonly value: number) {}

  getKey(): string {
    return this.KEY
  }

  getValue(): number {
    return this.value
  }
}
